module.exports = __webpack_public_path__ + "static/media/course_mobile.a2ed085f.png";